import React from 'react';
import { NamedLink, AvatarLarge, AvatarMedium } from '../../components';

import css from './ListingPage.module.css';

const SectionAmenitiesMaybe = props => {
  const { amenitiesForModal } = props;
  return (
    <div className={css.AmenitiesWrapper}>
      <div className={css.amenitiesHeading}>All Amenities</div>
      <ul>
      	{amenitiesForModal?.map((item, index)=>(
      		<li key={index}>{item?.label}</li>
      	))}
      </ul>
    </div>
  );
};

export default SectionAmenitiesMaybe;